import { render, staticRenderFns } from "./register.page.vue?vue&type=template&id=ec5cfb14&scoped=true&"
import script from "./register.page.vue?vue&type=script&lang=js&"
export * from "./register.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5cfb14",
  null
  
)

export default component.exports